import { Component, Input, OnChanges } from '@angular/core';

import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { AbstractFilterTypeComponent } from '../../models/abstract-filter-type.component';
import { FilterTypeRadioModel } from '../../models/filter-type-radio.model';

@Component({
    selector: 'agpr-filter-radio',
    templateUrl: './filter-radio.component.html',
    styleUrls: ['./filter-radio.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: FilterRadioComponent
        }
    ],
    standalone: false
})
export class FilterRadioComponent extends AbstractFilterTypeComponent implements OnChanges {
    @Input() declare filter: FilterTypeRadioModel;

    readonly buttonTypes = ButtonTypesEnum;

    value: any;

    ngOnChanges(): void {
        this.refresh();
    }
    /**
     * Refreshes the current value of the filter
     */
    refresh(): void {
        this.value = this.filter.getCurrentValue();
    }

    /**
     * Updates the current value of the filter
     */
    handleChange(value): void {
        this.filter.setCurrentValue(value);
    }
}
